var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4509_14622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.09119C3.5 1.26276 2.82843 0.591187 2 0.591187C1.17157 0.591187 0.5 1.26276 0.5 2.09119C0.5 2.91961 1.17157 3.59119 2 3.59119C2.82843 3.59119 3.5 2.91961 3.5 2.09119Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.09119C3.5 6.26276 2.82843 5.59119 2 5.59119C1.17157 5.59119 0.5 6.26276 0.5 7.09119C0.5 7.91961 1.17157 8.59119 2 8.59119C2.82843 8.59119 3.5 7.91961 3.5 7.09119Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12.0912C3.5 11.2628 2.82843 10.5912 2 10.5912C1.17157 10.5912 0.5 11.2628 0.5 12.0912C0.5 12.9196 1.17157 13.5912 2 13.5912C2.82843 13.5912 3.5 12.9196 3.5 12.0912Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4509_14622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 3,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.5 13.5912)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.702483deccd9558bf67cf214064300d7.svg";
export { ForwardRef as ReactComponent };